/* eslint-disable */
import React from 'react';
import { TrackedLink } from 'ci-common-ui';
import { trackEvent } from '../../services/telemetry-service/telemetry-service';

export const Link = (props) => <TrackedLink {...props} trackEvent={trackEvent}>{props.children}</TrackedLink>;
